<template>
  <footer class="footer">
    <!--Blue bar-->
  </footer>
</template>


<script>

export default {
  name: "TheFooter"
}

</script>


<style lang="scss" scoped>

footer.footer {
  background: #1226aa;
  height: 117px;
}

</style>